import { fetchVipFollowers, VipFollowersParamsType } from '@/api/fetchVipFollowers'
import { QUERY_KEY } from '@/constants/queryKey'
import { useQuery } from 'react-query'

const useVipFollowers = ({ merchantId, enabled }: VipFollowersParamsType & { enabled?: boolean }) => {
  const props = useQuery([QUERY_KEY.FETCH_VIP_FOLLOWERS, { merchantId }], () => fetchVipFollowers({ merchantId }), {
    enabled: !!merchantId && !!enabled,
  })

  return { ...props }
}

export default useVipFollowers
